import { useContext } from "react";
import Context from "./context";

const useProjects = () => {
  const projects = useContext(Context);
  return projects;
};

export default useProjects;
